import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

const inlineNoticeVariants = cva('rounded-lg border px-3 py-2 text-[13px] font-semibold', {
	variants: {
		tone: {
			muted: 'border-border bg-card text-text-muted',
			accent: 'border-accent/40 bg-accent/[0.08] text-accent',
			warn: 'border-warn/40 bg-warn/10 text-warn',
			danger: 'border-danger/40 bg-danger/10 text-danger',
		},
		mb: {
			sm: 'mb-2',
			md: 'mb-4',
			lg: 'mb-4',
		},
	},
	defaultVariants: {
		tone: 'muted',
	},
});

export interface InlineNoticeProps {
	/** Colore dell'avviso. Default: `muted`. */
	tone?: VariantProps<typeof inlineNoticeVariants>['tone'];
	/** Margine inferiore verso l'elemento successivo. */
	mb?: VariantProps<typeof inlineNoticeVariants>['mb'];
	/** Testo dell'avviso. */
	children: React.ReactNode;
}

/** Avviso contestuale su una riga (scope mancante, suggerimenti, warning leggeri). */
const InlineNotice = ({ tone, mb, children }: InlineNoticeProps) => (
	<div className={inlineNoticeVariants({ tone, mb })}>{children}</div>
);
InlineNotice.displayName = 'InlineNotice';

export { InlineNotice, inlineNoticeVariants };
